'use client';
import React from 'react';
import { Button } from '@benzinga/core-ui';
import { BzImage } from '@benzinga/image';
import { DentalInsurancePlan } from '@benzinga/content-manager';
interface InsurancePlanProp {
  plan: DentalInsurancePlan;
  quoteRequestId: string;
}

export const InsurancePlan: React.FC<InsurancePlanProp> = ({ plan, quoteRequestId }) => {
  const convertToSlug = text => {
    return text.toLowerCase().replace(/[^A-Z0-9]/gi, '-');
  };

  const [expandView, setExpandView] = React.useState(false);

  const getPlanURL = (plan: DentalInsurancePlan) => {
    return (
      'https://aff.dentalinsurance.com/quoting/' +
      convertToSlug(plan.carrier.name) +
      '/' +
      convertToSlug(plan.name) +
      '?requestId=' +
      quoteRequestId
    );
  };

  const planInfo = {
    cleaning: 'Cleaning: ',
    crown: 'Crown: ',
    deductible: 'Deductible: ',
    effectiveDateDetails: 'Date Details: ',
    filling: 'Filling: ',
    planMaximum: 'Maximum Plan: ',
    waitingPeriods: 'Waiting Periods: ',
  };

  return (
    <div className="plan-row-wrapper bz3-plan-data-row p-2">
      <div className="flex">
        <div className="w-2/3">
          <BzImage
            alt={plan.carrier.name}
            height="50px"
            src={'https://enrollmentwebdevelop.azurewebsites.net/' + plan.carrier.logoUrl.replace(/img/g, 'images')}
            title={plan.carrier.name}
            width="100%"
          />
          <h5 className="member-plan-name">{plan.name}</h5>
        </div>
        <div className="w-1/4">
          <p className="member-plan-price">
            ${plan.premium.toFixed(2)}
            <sub>/mo</sub>
          </p>
        </div>
        <div className="w-1/4">
          <div className="plan-action-cell">
            <Button as="a" className="mb-2" href={getPlanURL(plan)} size="sm" variant="flat-orange">
              Select Plan
            </Button>
            <div className="bz3-plan-data-more">
              <div
                className="bz3-plan-data-more-link"
                onClick={() => {
                  setExpandView(value => !value);
                }}
              >
                <span className="sub-click">More</span> Details{' '}
                <i aria-hidden="true" className="fa fa-chevron-circle-down"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      {expandView && (
        <div className="plan-more-details-wrapper">
          <ul>
            <li>
              <strong>Company Name: </strong>
              {plan.carrier.name}
            </li>
            {Object.entries(planInfo).map(([key, label]) => {
              return (
                <li key={key}>
                  {Object.prototype.hasOwnProperty.call(plan, key) && (
                    <>
                      {label}
                      {plan[key]}
                    </>
                  )}
                </li>
              );
            })}
            <li>
              <strong>Plan Type: </strong>
              {plan.planType.name}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};
